import React from "react";
import PropTypes from "prop-types";
import { BASE_ASSETS_URL } from "constants/app";
import { appendBetaInUrl } from "utils/redirection";

import styles from "./pageLoader.scss";

const {
  page_loader,
  inside_page_loader,
  loader_header,
  unauth_container,
  inside_header,
  logo,
  navbar_right,
  shimmer_box,
  box_inside,
  visual,
  sidebar_loader,
  bggrey,
  heading,
  group,
  greeting_loader,
  loader_right_content,
  loader_row,
  loader_sidbar,
  card,
  loader_title,
  loader_boday,
  text_m,
  text_l,
  text_s,
  greeting_loader_card,
} = styles;

function Header({ isAuthView }) {
  return (
    <div className={loader_header}>
      <div className={isAuthView ? "container" : unauth_container}>
        <div className={inside_header}>
          <a href={appendBetaInUrl("https://www.airtel.in/business/thanksforbusiness/selfcare/")} className={logo}>
            <img
              className={styles.display_big}
              src={
                isAuthView
                  ? `${BASE_ASSETS_URL}images/airtel-business-logo.svg`
                  : `${BASE_ASSETS_URL}images/Airtel_Business_Logo_Black.svg`
              }
              alt="Airtel Business "
            />
          </a>
          <div className={navbar_right}>
            <div className={shimmer_box}>
              <div className={box_inside}>
                <span className={visual}></span>
                <span className={visual}></span>
                <span className={visual}></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Sidebar() {
  return (
    <div className={sidebar_loader}>
      <div className={bggrey}>
        <div className={shimmer_box}>
          <div className={box_inside}>
            <div className={heading}>
              <span className={visual}></span>
            </div>
          </div>
        </div>
      </div>
      <div className={group}>
        <div className={shimmer_box}>
          <div className={box_inside}>
            <div className={heading}>
              <span className={visual}></span>
            </div>
            <div className={heading}>
              <span className={visual}></span>
            </div>
            <div className={heading}>
              <span className={visual}></span>
            </div>
            <div className={heading}>
              <span className={visual}></span>
            </div>
            <div className={heading}>
              <span className={visual}></span>
            </div>
            <div className={heading}>
              <span className={visual}></span>
            </div>
            <div className={heading}>
              <span className={visual}></span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

function Content() {
  return (
    <React.Fragment>
      <div className={card}>
        <div className={shimmer_box}>
          <div className={box_inside}>
            <div className={loader_title}>
              <span className={visual}></span>
            </div>
            <div className={loader_boday}>
              <span className={`${visual} ${text_m}`}></span>
              <span className={`${visual} ${text_l}`}></span>
              <span className={`${visual} ${text_s}`}></span>
              <span className={`${visual} ${text_m}`}></span>
            </div>
          </div>
        </div>
      </div>
      <Card />
    </React.Fragment>
  );
}

function Card() {
  return (
    <div className={card}>
      <div className={shimmer_box}>
        <div className={box_inside}>
          <div className={loader_title}>
            <span className={visual}></span>
          </div>
          <div className={loader_boday}>
            <span className={`${visual} ${text_m}`}></span>
            <span className={`${visual} ${text_l}`}></span>
            <span className={`${visual} ${text_s}`}></span>
            <span className={`${visual} ${text_l}`}></span>
            <span className={`${visual} ${text_s}`}></span>
          </div>
        </div>
      </div>
    </div>
  );
}

function GreetingCard() {
  return (
    <div className={greeting_loader}>
      <div className={greeting_loader_card}>
        <div className="container">
          <div className={shimmer_box}>
            <div className={box_inside}>
              <div className={loader_boday}>
                <span className={`${visual} ${text_l}`}></span>
                <span className={`${visual} ${text_m}`}></span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

const PageLoader = ({ isAuthView = true, isLayoutView, isCardView, children, noOfCardsToShow = 1 }) => {
  if (isCardView) {
    return (
      <div className={page_loader}>
        {children}
        {Array.from({ length: noOfCardsToShow }, (x, i) => i).map((e, key) => (
          <>
            <Card key={key} />
            <br />
          </>
        ))}
      </div>
    );
  }
  if (isLayoutView) {
    return <div className={page_loader}>{children ?? <Content />}</div>;
  }
  if (isAuthView) {
    return (
      <div className={page_loader}>
        <Header isAuthView={isAuthView} />
        <GreetingCard />
        <div className={inside_page_loader}>
          <div className="container">
            <div className={loader_row}>
              <div className={loader_sidbar}>
                <Sidebar />
              </div>
              <div className={loader_right_content}>{children ?? <Content />}</div>
            </div>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className={page_loader}>
      <Header isAuthView={isAuthView} />
      <div className={unauth_container}>
        <Content />
      </div>
    </div>
  );
};

PageLoader.defaultProps = {
  isAuthView: true,
  isLayoutView: false,
  isCardView: false,
};

PageLoader.propTypes = {
  isAuthView: PropTypes.bool,
  isLayoutView: PropTypes.bool,
  isCardView: PropTypes.bool,
};

export default PageLoader;
